import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data
  })
}

export function getInfo(id) {
  return request({
    url: 'account/infoByID',
    method: 'post',
    data: {
      id: id
    }
  })
}

export function logout() {
  return request({
    url: 'logout',
    method: 'get',
    data: {}
  })
}
// 添加账号
export function addAccount(data) {
  return request({
    url: 'account/add',
    method: 'post',
    data: data
  })
}

// 修改账号信息
export function editAccount(data) {
  return request({
    url: 'account/update',
    method: 'post',
    data: data
  })
}
// 查询ftp用户列表
export function userslist(id) {
  return request({
    url: 'users/list',
    method: 'post',
    data: {
      projectId: id
    }
  })
}
// 查询项目列表
export function projectquery() {
  return request({
    url: 'project/query',
    method: 'post',
    data: {}
  })
}

// 分页查询账号列表
export function accountpage(data) {
  return request({
    url: 'account/page',
    method: 'post',
    data: data
  })
}
